import { render, staticRenderFns } from "./DailyWelcomeContent.ts.vue?vue&type=template&id=24dddbd0&"
import script from "./DailyWelcomeContent.ts.vue?vue&type=script&lang=ts&"
export * from "./DailyWelcomeContent.ts.vue?vue&type=script&lang=ts&"
import style0 from "./DailyWelcomeContent.ts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports